






























































import {Vue, Component, Prop, Ref} from "vue-property-decorator"
import GenericTemplate from "@/pages/Pages/Templates/GenericTemplate.vue";
import {MsgTransports} from "@/store/types";
import {TemplateItem, TemplateItemImpl} from "@/store/settings/templates/types";
import {Route} from "vue-router";
import SmsTextInputWings from "@/components/SMS/SmsTextInputWings.vue";

Component.registerHooks(["beforeRouteLeave"]);

@Component({components: {SmsTextInputWings, GenericTemplate}})
export default class WhatsappTemplate extends Vue {

  @Prop() moderation!: boolean;

  @Ref("genericTemplate") genericTemplate!: GenericTemplate;

  private transport: MsgTransports = MsgTransports.WHATSAPP;
  private templateObject: TemplateItem = new TemplateItemImpl();

  beforeRouteLeave(to: Route, from: Route, next: any) {
    this.genericTemplate.beforeLeave(to, from, next);
  }
  onLoadTemplate(status: string) {
    if (this.moderation) {
      this.$emit('onLoadTemplate', status)
    }
  }
}
